export default __webpack_public_path__ + "locales/passes.kk.json";